<template>
  <div class="federated-search-wrapper">
    <insided-embed  page="homepage" type="hero_banner" :community-url="communityUrl" />
  </div>
</template>

<script setup>
import '../../../../web-resources/v2/js/widget-loader';

defineProps({
  communityUrl: {
    type: String,
    default: null
  }
});

</script>
